<script>import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const ArrowIcon = getIcon("ArrowIcon");
export let className = "";
</script>

{#if typeof ArrowIcon === 'string'}
	<img src={ArrowIcon} alt={$t(Verbiage.arrow_icon_alt, 'alts')} class={className} />
{:else if typeof ArrowIcon === 'function'}
	<svelte:component this={ArrowIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
